import Grid from "@material-ui/core/Grid";
import { SelectProps } from "@material-ui/core/Select";
import { Form, Formik } from "formik";
import React from "react";
import CustomDropdownMultiple from "../../../components/Input/CustomDropdownMultiple";
import { useLaboratories } from "../../../contexts/LaboratoriesContext";
import CSCLaboratory from "./CSCLaboratory";
import UserGroup, { userGroupDictionary, userGroupOptions } from "./userGroups";
import UserRole, { userRoleDictionary, userRoleOptions } from "./userRoles";

export type UserActivityFilters = {
  groups: UserGroup[];
  labs: CSCLaboratory[];
  roles: UserRole[];
};

interface AdminUserOverviewFiltersProps {
  handleFilterChange: (filters: UserActivityFilters) => void;
  initialValues: UserActivityFilters;
}

const AdminUserOverviewFilters: React.FC<AdminUserOverviewFiltersProps> = ({ handleFilterChange, initialValues }) => {
  const { labsTechnical: laboratoryOptions, labsDictionary: laboratoryDictionary } = useLaboratories();

  return (
    <Formik<UserActivityFilters>
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values) => {
        handleFilterChange(values);
      }}
    >
      {({ dirty, handleChange, submitForm, values }) => {
        const handleMenuClose = () => {
          if (dirty) {
            submitForm();
          }
        };

        // ! workaround to make CustomDropdownMultiple behave similar to CustomDropdown
        // TODO remove once implementation allows for multiple values per filter
        const handleSelectChange: SelectProps["onChange"] = (e) => {
          const { name, value: newValue } = e.target as {
            name: keyof UserActivityFilters;
            value: Array<any>;
          };
          const oldValue = values[name];
          if (newValue[0] === "EMPTY_OPTION") return;
          if (oldValue.length === 0 || newValue.length <= oldValue.length) {
            handleChange(e);
            return;
          }
          if (newValue.length > oldValue.length) {
            handleChange({
              ...e,
              target: {
                name,
                value: [newValue[1]],
              },
            });
          }
        };

        return (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <CustomDropdownMultiple
                  chips
                  labelText="Laboratory"
                  name="labs"
                  onClose={handleMenuClose}
                  // onChange={handleChange}
                  onChange={handleSelectChange}
                  noOptionsLabel="Loading..."
                  options={laboratoryOptions}
                  optionsDictionary={laboratoryDictionary}
                  value={values.labs}
                />
              </Grid>
              <Grid item xs={4}>
                <CustomDropdownMultiple
                  chips
                  labelText="User Group"
                  name="groups"
                  // onChange={handleChange}
                  onChange={handleSelectChange}
                  onClose={handleMenuClose}
                  options={userGroupOptions}
                  optionsDictionary={userGroupDictionary}
                  value={values.groups}
                />
              </Grid>
              <Grid item xs={4}>
                <CustomDropdownMultiple
                  chips
                  labelText="User Role"
                  name="roles"
                  // onChange={handleChange}
                  onChange={handleSelectChange}
                  onClose={handleMenuClose}
                  options={userRoleOptions}
                  optionsDictionary={userRoleDictionary}
                  value={values.roles}
                />
              </Grid>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AdminUserOverviewFilters;
